module.exports = __webpack_public_path__ + "img/faber-logo-white.731b0b48.svg";